import { AdminNotificationsProvider } from '@/context/AdminNotificationsContext';
import { Outlet } from 'react-router-dom';

export default function AdminLayout() {
  console.log('✅ AdminLayout monté');  // ← ajoute ça
  return (
    <AdminNotificationsProvider>
      <Outlet />
    </AdminNotificationsProvider>
  );
}